export const GET_ARTICLE_TAGS = "GET_ARTICLE_TAGS";
export const GET_ARTICLE_TAGS_FAIL = "GET_ARTICLE_TAGS_FAIL";
export const GET_ARTICLE_TAGS_SUCCESS = "GET_ARTICLE_TAGS_SUCCESS";
export const GET_ARTICLE_TAGS_RESET = "GET_ARTICLE_TAGS_RESET";

export const getArticleTags = (params) => {
  return { type: GET_ARTICLE_TAGS, params };
};
export const getArticleTagsFail = (response) => {
  return { type: GET_ARTICLE_TAGS_FAIL, response };
};
export const getArticleTagsSuccess = (response) => {
  return { type: GET_ARTICLE_TAGS_SUCCESS, response };
};
export const getArticleTagsReset = () => {
  return { type: GET_ARTICLE_TAGS_RESET };
};
